// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__27HWr","logo":"Header_logo__175a2","home":"Header_home__24Z6n","homeIcon":"Header_homeIcon__MlShG","unlockIcon":"Header_unlockIcon__2W2ba"};